import React, { Suspense, useEffect, useState } from 'react';
import './App.scss';
import { useLocation } from 'react-router';
import { Container } from 'react-bootstrap';
import MainNavbar from '../../components/MainNavbar';
import MainFooter from '../../components/MainFooter';
import { useAppDispatch } from '../../redux/hooks';
import initialization from '../../helpers/initialization';
import {
	fetchUserPermissionsThunk,
	setLoggedInStatus,
} from '../../redux/slicers/authenticationSlice';
import deinitialization from '../../helpers/deinitialization';
import useGoogleTracking from '../../helpers/hooks/useGoogleTracking';
import AppRoutes from '../../router/routes';

const App = () => {
	const dispatch = useAppDispatch();

	const location = useLocation();

	const [loading, setLoading] = useState<boolean>(true);
	const [isLoginView, setIsLoginView] = useState<boolean>(true);

	useGoogleTracking();

	useEffect(() => {
		(async () => {
			setLoading(true);
			const userStatus = await initialization.initializeUser(true);
			if (!userStatus) {
				setLoading(false);
				return;
			}
			const requiredPermissions: string[] = [
				'readings.view_tag',
				'locations.view_organization',
				'locations.view_building',
				'readings.view_device',
				'accounts.view_user',
				'readings.view_devicetype',
			];
			const permissionsStatus = await dispatch(fetchUserPermissionsThunk());
			if (
				!permissionsStatus ||
				!requiredPermissions.every((per) => (permissionsStatus.payload as string[]).includes(per))
			) {
				deinitialization.userLogout(true);
				setLoading(false);
				return;
			}
			const dataStatus = await initialization.initializeData(userStatus.user, true);
			if (!dataStatus) {
				deinitialization.userLogout(true);
				setLoading(false);
				return;
			}
			await dispatch(setLoggedInStatus(true));
			setLoading(false);
		})();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(() => {
		const path = location.pathname.split('/');
		document.title = definePageTile(path);
		setIsLoginView(path[1] === 'login');
		function definePageTile(title: string[]): string {
			switch (title[1]) {
				case 'login':
					return 'Log in | EnergyAnalytics';
				case 'dashboard':
					return 'Dashboard | EnergyAnalytics';
				case 'device-channels-configuration':
					return 'Device channels configuration | EnergyAnalytics';
				case 'energy-consumption':
					return 'Energy consumption | EnergyAnalytics';
				case 'monthly-report':
					return 'Monthly report | EnergyAnalytics';
				case 'weekly-report':
					return 'Weekly report | EnergyAnalytics';
				default:
					return 'EnergyAnalytics';
			}
		}
	}, [location]);

	return !loading ? (
		<div className={`d-flex flex-column min-vh-100 ${isLoginView && 'login-page'} `}>
			<MainNavbar />
			<Suspense>
				<main
					className={`${!isLoginView ? 'd-flex flex-fill mt-3' : 'd-flex justify-content-center align-items-center flex-fill'}  `}
				>
					<Container fluid="lg">
						<AppRoutes></AppRoutes>
					</Container>
				</main>
			</Suspense>
			<MainFooter />
		</div>
	) : (
		<></>
	);
};

export default App;
